import { Component, OnInit } from '@angular/core';
import { NotificationService } from 'src/app/shared/services';
import { ModalService } from 'src/app/shared/modules/modal';
import {
  ClosableModalWithErrorResponseModel
} from 'src/app/shared/components/base/closable-modal-with-error-response-model';

import { InternalLocalFileReportService } from '../../../shared/services';
import { TranslationConstants } from '../../../shared/constants';

@Component({
  selector: 'edit-internal-localfile-report-title-modal',
  templateUrl: './edit-internal-localfile-report-title-modal.component.html',
})

export class EditInternalLocalfileReportTitleModalComponent extends ClosableModalWithErrorResponseModel <any> implements OnInit {

  data: any;
  reportTitle: string;
  reportId: number;

  constructor(
    protected notificationService: NotificationService,
    protected modalService: ModalService,
    private _internalLocalfileReportService: InternalLocalFileReportService
  ) {
    super(notificationService, modalService);
  }

  ngOnInit() {
    this.listenForErrorMessages();
    this.reportTitle = this.data.reportData.name;
    this.reportId = this.data.reportData.internalLocalfileReportId;
  }

  submitNewTitle(): void {
    const errorMessages = this.validateTitlePayload(this.reportTitle);

    if (errorMessages.length) {
      this.responseErrors = errorMessages;
      return;
    }

    this._internalLocalfileReportService.updateTitle(this.reportTitle, this.reportId).subscribe(() => {
      this.success();
      this.exitModal();
    });
  }

  validateTitlePayload(title: string): string[] {
    const errorMessages = [];

    if (!title) {
      errorMessages.push(TranslationConstants.REPORT_GENERATION_REPORT_TITLE_REQUIRED);
    }

    return errorMessages;
  }

  exitModal(): void {
    this.closeAllModals();
  }

}
